// extracted by mini-css-extract-plugin
export var wrapper = "hero-module--wrapper--34CgE";
export var mainBox = "hero-module--main-box--e-gMZ";
export var textGradient = "hero-module--text-gradient--2cXMW";
export var subTitle = "hero-module--sub-title--3wjNQ";
export var buttonWrapper = "hero-module--button-wrapper--3W5ka";